module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/setting/items/items-show/items-show.component.scss
// module id = ./src/app/views/setting/items/items-show/items-show.component.scss
// module chunks = main